import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";

export default function Blog() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 py-16" data-testid="blog-page">
      <Seo
        title="Blog — Insights & Encouragement"
        description="Honest reflections on growth, relationships, and building a stronger life, written by Laura Combs. Articles, insights, and announcements from Laura Combs Productions."
        path="/blog"
      />
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-gold text-sm uppercase tracking-[0.3em]">Blog</span>
        <h1 className="font-serif text-5xl sm:text-6xl text-forest mt-4">Insights &amp; Encouragement</h1>
        <p className="text-charcoal/70 mt-5 leading-relaxed">
          Short, honest reflections on growth, relationships, and building a stronger life —
          from Laura's desk to yours.
        </p>
      </div>

      {loading ? (
        <div className="text-center text-charcoal/50 py-20">Loading…</div>
      ) : articles.length === 0 ? (
        <div className="text-center text-charcoal/50 py-20">New posts coming soon.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="articles-grid">
          {articles.map((a) => (
            <Link
              key={a.id}
              to={`/blog/${a.slug}`}
              className="group bg-white rounded-2xl border border-gold/30 shadow-sm hover:shadow-md transition-shadow overflow-hidden flex flex-col"
              data-testid={`article-card-${a.slug}`}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={a.cover_image || "https://images.unsplash.com/photo-1458014854819-1a40aa70211c?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"} alt={a.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" decoding="async" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <span className="text-gold text-xs uppercase tracking-widest">{a.category}</span>
                <h2 className="font-serif text-2xl text-forest mt-2 leading-tight">{a.title}</h2>
                <p className="text-charcoal/60 text-sm mt-3 flex-1">{a.excerpt}</p>
                <span className="text-forest text-sm mt-5 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                  Read more <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
